// Varyant Sözlüğü penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'inventory.variantDictionary';

export const inventoryVariantDictionaryGuide = (t: TFunction): GuideContent => ({
  layout: 'split',
  title: t(`${G}.title`, 'Varyant tipleri ve değerleri nasıl tanımlanır?'),
  intro: t(`${G}.intro`, 'Varyant Sözlüğü, ürün varyantlarında kullanacağınız tipleri (Renk, Beden, Uzunluk vb.) ve bu tiplerin değerlerini (Kırmızı, M, 42 vb.) tanımladığınız yerdir. Burada tanımlanan tipler "Varyantları Yönet" penceresindeki matriste seçilebilir.'),
  regionLabels: {
    list: t(`${G}.regions.list`, 'Tipler'),
    form: t(`${G}.regions.form`, 'Seçili tipin değerleri'),
    footer: t(`${G}.regions.footer`, 'Kapat'),
  },
  steps: [
    {
      region: 'list',
      title: t(`${G}.s1.title`, '1. Soldan bir tip seçin'),
      text: t(`${G}.s1.text`, 'Sol paneldeki "Tipler" listesinden bir tip seçin (Renk, Beden, Uzunluk vb.). Her tipin altında kaç değeri olduğu yazar.'),
    },
    {
      region: 'list',
      title: t(`${G}.s2.title`, '2. Yeni tip ekleyin'),
      text: t(`${G}.s2.text`, '"Yeni tip (örn. Renk)" kutusuna adı yazıp "Ekle"ye basın. Aynı adda bir tip varsa yeni tip açılmaz, mevcut tip seçilir.'),
      tips: [
        t(`${G}.s2.tip1`, 'Yeni tip, ilk değerini ekleyene kadar kalıcı olmaz ("Henüz değeri yok"). Pencereyi değer eklemeden kapatırsanız tip kaybolur.'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s3.title`, '3. Sağda değerleri ekleyin'),
      text: t(`${G}.s3.text`, 'Sağ panelde seçili tipin değerlerini ekleyin: "Değer (örn. Kırmızı)" zorunludur, "Kod (ops.)" isteğe bağlıdır. "Ekle"ye ya da Enter tuşuna basın. Yeni değer listenin sonuna eklenir.'),
    },
    {
      region: 'form',
      title: t(`${G}.s4.title`, '4. Değeri düzenleyin veya silin'),
      text: t(`${G}.s4.text`, 'Satırdaki kalem simgesi değeri forma getirir; adı, kodu ve "Sıra"yı değiştirip "Güncelle"ye basın ("İptal" vazgeçer). Çöp kutusu simgesi onay sorduktan sonra değeri siler; kalan değerlerin sırası 1\'den başlayarak yeniden numaralanır.'),
    },
    {
      region: 'list',
      title: t(`${G}.s5.title`, '5. Tipi silin'),
      text: t(`${G}.s5.text`, '"Tipi Sil" seçili tipi tüm değerleriyle birlikte, onay sorduktan sonra siler.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Kapatın ve matriste kullanın'),
      text: t(`${G}.s6.text`, '"Kapat"a basın. Eklediğiniz tip ve değerler "Varyantları Yönet" penceresindeki tip listelerinde ve matriste hemen görünür.'),
    },
  ],
});
